<template>
    <div class="dateTimePicker" ref="wrap">
        <b-input :value="displayTime" readonly @click="togglePicker" ref="input" @keydown="onInputKeyDown">
        </b-input>
        <transition name="myFade" enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div v-show="pickerShown">
                <div class="screencover" @click="hidePicker"></div>
                <div :class="{ picker: true, dateTime: !timeOnly && !dateOnly, dateOnly, timeOnly, showDate:
                !timeOnly, showTime: !dateOnly }"
                        @keydown="focusHandler" ref="dropdown" :style="styles">
                    <div class="calendarwrap" tabindex="0" @keydown="onCalendarKeyDown" ref="calendar"
                            v-if="!timeOnly">
                        <div class="datewrap" :class="{ hide: mode !== 'date'}">
                            <div class="monthtitle">

                                <span @click="changeMonth(-1)" >
                                    <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                                </span>
                                <span @click="mode='month'">{{val.monthLong}}</span>
                                <span @click="mode='year'">{{val.year}}</span>
                                <span @click="changeMonth(1)">
                                    <font-awesome-icon icon="chevron-right"></font-awesome-icon>
                                </span>
                            </div>
                            <div class="monthview">
                                <div v-for="d in weekDays" :key="`wd-${d.key}`" class="dayTitle">{{d.name}}</div>
                                <div v-for="d in daysToShow" :key="d.key" class="day" @click="selectDay(d)"
                                        :class="{[d.class]: true, selected: d.date.hasSame(val, 'day'),
                                        blocked: d.block}">{{d.date
                                    .day}}</div>
                            </div>
                        </div>
                        <div v-show="mode==='month'" class="monthwrap">
                            <div class="cancelListView">
                            <span class="cancelButton">
                                <font-awesome-icon icon="times" @click="mode='date'"></font-awesome-icon>
                            </span>
                            </div>
                            <div class="monthlist">
                                <div v-for="(m, ind) in monthList" :key="`m-${ind}`" class="month"
                                        @click="selectMonth(m)"
                                        :class="{selected: m.date.hasSame(val, 'month'), blocked: m.block}">
                                    {{m.date.monthLong}}
                                </div>
                            </div>
                        </div>
                        <div v-show="mode==='year'" class="yearwrap">
                            <div class="cancelListView">
                            <span class="cancelButton">
                                <font-awesome-icon icon="times" @click="mode='date'"></font-awesome-icon>
                            </span>
                            </div>
                            <div class="yearlist">
                                <div v-for="(y, ind) in yearList" :key="`y-${ind}`" class="year" @click="selectYear(y)"
                                        :class="{selected: y.date.hasSame(val, 'year'), blocked: y.block}">
                                    {{y.date.year}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="timewrap" v-if="!dateOnly">
                        <div class="hourlist" ref="hourList" @wheel="doScrollHours($event)" tabindex="0"
                                @keydown="onHourKeyDown">
                            <div v-for="(h, ind) in hours" :key="`h-${ind}`" class="hour" @click="selectHour(h)"
                                        :class="{[`time-${timeRows}-${ind}`]: true, selected: val.hour === h.value,
                                        valid: !h.block}">
                                {{h.value}}
                            </div>
                        </div>
                        <div class="minutelist" @wheel="doScrollMinutes($event)" tabindex="0"
                                @keydown="onMinuteKeyDown">
                            <div v-for="(m, ind) in minutes" :key="`m-${ind}`" class="minute" @click="selectMinute(m)"
                                    :class="{[`time-${timeRows}-${ind}`]: true, selected: val.minute === m.value,
                                    valid: !m.block}">
                                {{m.value}}
                            </div>
                        </div>
                    </div>

                    <div class="bottom">
                        <div class="date">{{fullDisplayTime}}</div>
                        <div class="buttons">
                            <b-button @click="removeValue" v-if="optional" class="mr-3">
                                <font-awesome-icon icon="eraser"></font-awesome-icon>
                                {{$t('clear')}}</b-button>
                            <div v-if="timeOnly" class="mb-2"></div>
                            <b-button @click="hidePicker"><font-awesome-icon icon="times"></font-awesome-icon>
                                {{$t('cancel')}}</b-button>
                            <b-button @click="saveAndHidePicker" class="ml-3" variant="primary"
                            ref="lasttab"><font-awesome-icon icon="check"></font-awesome-icon>
                            {{$t('ok')}}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'dateTimePicker',
  components: { FontAwesomeIcon },
  i18nOptions: { keyPrefix: 'dateTimePicker' },
  data: function() {
    return {
      val: DateTime.local(),
      pickerShown: false,
      mode: 'date',
      dateSelected: true,
      top: false,
      topOffset: 0
    };
  },
  props: {
    value: String,
    minuteStep: {
      type: Number,
      default: 5
    },
    minvalue: String,
    maxvalue: String,
    dateOnly: Boolean,
    timeOnly: Boolean,
    optional: Boolean,
    closeOnClick: Boolean,
    noDateText: String,
    noTimeText: String,
    storeUTC: Boolean
  },
  watch: {
    value() {
      this.loadValue();
    }
  },
  mounted() {
    this.loadValue();
  },
  methods: {
    loadValue() {
      if (this.value) {
        this.val = DateTime.fromISO(this.value);
        this.dateSelected = true;
      } else {
        this.val = DateTime.local();
        this.val = this.val.set({ minute: Math.floor(this.val.minute / this.minuteStep) * this.minuteStep,
          second: 0,
          millisecond: 0
        });
        if (this.optional) {
          this.dateSelected = false;
        }
      }
      console.log('datetimepicker load - ', this.value, this.val);
    },
    focusHandler(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (e.srcElement === this.$refs.calendar) {
            this.$refs.lasttab.focus();
            e.preventDefault();
          }
        } else {
          if (e.srcElement === this.$refs.lasttab) {
            this.$refs.calendar.focus();
            e.preventDefault();
          }
        }
      }
    },
    onInputKeyDown(e) {
      switch (e.key) {
        case 'ArrowDown':
        case ' ':
        case 'Enter':
          this.showPicker();
          break;
        case 'Escape':
        case 'ArrowUp':
          this.hidePicker();
          e.stopPropagation();
          break;
      }
    },
    onCalendarKeyDown(e) {
      switch (e.key) {
        case 'ArrowRight':
          this.val = this.val.plus({ days: 1 });
          e.preventDefault();
          break;
        case 'ArrowLeft':
          this.val = this.val.minus({ days: 1 });
          e.preventDefault();
          break;
        case 'ArrowDown':
          this.val = this.val.plus({ days: 7 });
          e.preventDefault();
          break;
        case 'ArrowUp':
          this.val = this.val.minus({ days: 7 });
          e.preventDefault();
          break;
        case 'PageDown':
          this.val = this.val.plus({ months: 1 });
          e.preventDefault();
          break;
        case 'PageUp':
          this.val = this.val.minus({ months: 1 });
          e.preventDefault();
          break;
        case 'Home':
          {
            const now = DateTime.local();
            this.val = this.val.set({ year: now.year, ordinal: now.ordinal });
            e.preventDefault();
          }
          break;
        case 'Escape':
          this.hidePicker();
          e.stopPropagation();
          break;
      }
    },
    onHourKeyDown(e) {
      switch (e.key) {
        case 'ArrowDown':
          if (this.val.hour < 23) {
            this.val = this.val.plus({ hours: 1 });
          }
          e.preventDefault();
          break;
        case 'ArrowUp':
          if (this.val.hour > 0) {
            this.val = this.val.minus({ hours: 1 });
          }
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowRight':
          e.preventDefault();
          break;
        case 'Escape':
          this.hidePicker();
          e.stopPropagation();
          break;
      }
    },
    onMinuteKeyDown(e) {
      switch (e.key) {
        case 'ArrowDown':
          if (this.val.minute < (60 - this.minuteStep)) {
            this.val = this.val.plus({ minutes: this.minuteStep });
          }
          e.preventDefault();
          break;
        case 'ArrowUp':
          if (this.val.minute > this.minuteStep) {
            this.val = this.val.minus({ minutes: this.minuteStep });
          }
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowRight':
          e.preventDefault();
          break;
        case 'Escape':
          this.hidePicker();
          e.stopPropagation();
          break;
      }
    },
    togglePicker() {
      if (this.pickerShown) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    },
    showPicker() {
      this.pickerShown = true;
      this.top = false;
      this.topOffset = 0;
      this.$nextTick(() => {
        let rect = this.$refs.dropdown.getBoundingClientRect();
        let scrollParent = this.$refs.dropdown.closest('div.modal-body');
        let rectBottom = rect.bottom;
        let rectTop = rect.top;
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        if (scrollParent) {
          let parentRect = scrollParent.getBoundingClientRect();
          windowHeight = parentRect.height - 20;
          rectBottom -= parentRect.top;
          rectTop -= parentRect.top;
        }

        this.top = (rectBottom > windowHeight) && (rectTop >= rect.height);
        this.topOffset = windowHeight - rectBottom;
        this.$nextTick(() => {
          if (this.timeOnly) {
            this.$refs['hourList'].focus();
          } else {
            this.$refs['calendar'].focus();
          }
        });

        // this.$refs['calendar'].focus();
      });
    },
    removeValue() {
      this.$emit('input', '');
      this.hidePicker();
    },
    hidePicker() {
      this.pickerShown = false;
      this.loadValue();
      this.$nextTick(() => {
        this.$refs['input'].focus();
      });
    },
    saveAndHidePicker() {
      if (this.dateOnly) {
        this.$emit('input', this.val.toISODate());
      } else {
        if (this.storeUTC) {
          this.$emit('input', this.val.toUTC().toISO({ suppressMilliseconds: true }));
        } else {
          this.$emit('input', this.val.toISO({ suppressMilliseconds: true }));
        }
      }
      this.pickerShown = false;
      this.$nextTick(() => {
        this.$refs['input'].focus();
      });
    },
    validate() {
      if ((this.minValue) && (this.val < this.minValue)) {
        this.val = this.minValue;
        return false;
      }
      return true;
    },
    selectDay(d) {
      this.val = this.val.set({ year: d.date.year, ordinal: d.date.ordinal });
      if (this.validate()) {
        if (this.closeOnClick) {
          this.saveAndHidePicker();
        }
      }
    },
    selectMonth(m) {
      if (!m.block) {
        this.val = this.val.set({ month: m.date.month });
        this.mode = 'date';
        this.validate();
      }
    },
    selectYear(y) {
      if (!y.block) {
        this.val = this.val.set({ year: y.date.year });
        this.mode = 'date';
        this.validate();
      }
    },
    selectHour(h) {
      if (!h.block) {
        this.val = this.val.set({ hour: h.value });
      }
      this.validate();
    },
    selectMinute(m) {
      if (!m.block) {
        this.val = this.val.set({ minute: m.value });
      }
      this.validate();
    },
    changeMonth(offset) {
      this.val = this.val.plus({ months: offset });
    },
    doScrollMinutes(e) {
      if ((e.deltaY < 0) && (this.val.minute >= this.minuteStep)) {
        const temp = this.val.minus({ minutes: this.minuteStep });
        if (temp >= this.minValue) {
          this.val = temp;
        }
      } else if ((e.deltaY > 0) && (this.val.minute < (60 - this.minuteStep))) {
        const temp = this.val.plus({ minutes: this.minuteStep });
        this.val = temp;
      }
      e.preventDefault();
    },
    doScrollHours(e) {
      if ((e.deltaY < 0) && (this.val.hour > 0)) {
        const temp = this.val.minus({ hours: 1 });
        if (temp >= this.minValue) {
          this.val = temp;
        }
      } else if ((e.deltaY > 0) && (this.val.hour < 23)) {
        this.val = this.val.plus({ hours: 1 });
      }
      e.preventDefault();
    }
  },
  computed: {
    showMonth() {
      return this.val.startOf('month');
    },
    weekDays() {
      let days = [];
      let start = this.showMonth.minus({ day: this.showMonth.weekday - 1 });
      for (let i = 0; i < 7; i++) {
        days.push({ key: i, name: start.plus({ day: i }).toLocaleString({ weekday: 'short' }) });
      }
      return days;
    },
    daysToShow() {
      let days = [];
      let startDate = this.showMonth.minus({ days: this.showMonth.weekday - 1 });
      for (let i = 0; i < this.showMonth.weekday - 1; i++) {
        days.push({ key: days.length, class: 'not-valid', date: startDate.plus({ days: days.length }) });
      }
      for (let i = 1; i <= this.showMonth.daysInMonth; i++) {
        days.push({ key: days.length, class: 'valid', date: startDate.plus({ days: days.length }) });
      }
      while (days.length % 7 !== 0) {
        days.push({ key: days.length, class: 'not-valid', date: startDate.plus({ days: days.length }) });
      }

      days.forEach(d => {
        d.block = false;
        if ((this.minValue) && (d.date < this.minValue)) {
          if (!d.date.hasSame(this.minValue, 'day')) {
            d.block = true;
          }
        }
      });
      return days;
    },
    monthList() {
      let months = [];
      let startDate = this.val.startOf('year');
      for (let i = 0; i < 12; i++) {
        let block = false;
        const m = startDate.plus({ months: i });
        if ((this.minValue) && (m < this.minValue)) {
          if (!m.hasSame(this.minValue, 'month')) {
            block = true;
          }
        }
        months.push({ date: startDate.plus({ months: i }), block });
      }
      return months;
    },
    yearList() {
      let years = [];
      let startDate = this.val.startOf('year').minus({ years: 9 });
      for (let i = 0; i < 20; i++) {
        let block = false;
        if ((this.minValue) && (startDate.year + i < this.minValue.year)) {
          block = true;
        }
        years.push({ date: startDate.plus({ years: i }), block });
      }
      return years;
    },
    timeRows() {
      return (this.daysToShow.length / 7 === 5) ? 11 : 12;
    },
    hours() {
      let hours = [];
      let val = this.val.hour - 5;
      for (let i = 0; i < this.timeRows; i++) {
        if ((val < 0) || (val > 23)) {
          hours.push({ value: ' ', block: true });
        } else {
          let block = false;
          if ((this.minValue) && (this.val.hasSame(this.minValue, 'day'))) {
            if (this.minValue.hour > val) {
              block = true;
            }
          }
          hours.push({ value: val, block });
        }
        val++;
      }
      return hours;
    },
    minutes() {
      let minutes = [];
      let val = Math.floor(this.val.minute / this.minuteStep) * this.minuteStep;
      val = val - 5 * this.minuteStep;
      for (let i = 0; i < this.timeRows; i++) {
        if ((val < 0) || (val > 59)) {
          minutes.push({ value: ' ', block: true });
        } else {
          let block = false;
          if ((this.minValue) && (this.val.hasSame(this.minValue, 'hour'))) {
            if (this.minValue.minute > val) {
              block = true;
            }
          }
          minutes.push({ value: val, block });
        }
        val += this.minuteStep;
      }
      return minutes;
    },
    displayTime() {
      if (this.timeOnly) {
        if ((this.optional) && (!this.dateSelected)) {
          return this.noTimeText || this.$t('noTime');
        }
        return this.val.toFormat('H:mm');
      } else {
        if ((this.optional) && (!this.dateSelected)) {
          return this.noDateText || this.$t('noDate');
        }
        if (this.dateOnly) {
          return this.val.toLocaleString({ weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric' });
        } else {
          return this.val.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
        }
      }
    },
    fullDisplayTime() {
      if (this.timeOnly) {
        return this.val.toFormat('H:mm');
      } else if (this.dateOnly) {
        return this.val.toLocaleString({ weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric' });
      } else {
        return this.val.toLocaleString({ weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric' });
      }
    },
    minValue() {
      return this.minvalue ? DateTime.fromISO(this.minvalue) : null;
    },
    maxValue() {
      return this.maxvalue ? DateTime.fromISO(this.maxvalue) : null;
    },
    styles() {
      if (this.topOffset < 30) {
        return { top: `${this.topOffset}px` };
      } else {
        return {};
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .dateTimePicker {
        position: relative;
        display: inline-block;

        .screencover {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: transparent;
            z-index: 100;
        }

        .picker {
            position: absolute;
            z-index: 100;
            background-color: white;
            box-shadow: 0px 0px 3px 3px $gray-300;
            display: grid;
            grid-template-columns: auto auto;
            grid-template-rows: auto auto;
            grid-template-areas: "calendar time" "bottom bottom";
            &.timeOnly {
                grid-template-columns: 0px auto;
                grid-template-rows: 260px auto;
                grid-template-areas: "calendar time" "bottom bottom";
            }
        }

        .picker.timeOnly {
            .timewrap {
                width: 100%;
            }
        }

        .bottom {
            border-top: 1px solid $gray-300;
            padding: 3px;
            grid-area: bottom;
            .date {
                text-align: center;
            }
            .buttons {
                float: right;
            }
        }

        .timewrap {
            border-left: 1px solid $gray-300;
            // padding: 10px;
            height: 100%;
            width: 6em;
            position: relative;
            grid-area: time;

            .hourlist, .minutelist {
                position: absolute;
                top: 0;
                bottom: 0;
                overflow-y: hidden;
                height: 100%;
                width: 50%;
                text-align: center;
                &.minutelist {
                    left: 50%;
                }
                div {
                    height: 1.5em;
                    position: relative;
                    color: $datetimepicker-blocked-time;
                    &.selected {
                        background-color: $datetimepicker-selected-day !important;
                        font-weight: bold;
                    }
                    &.valid {
                        color: black;
                    }
                    &.valid:hover {
                        background-color: $datetimepicker-hover-day;
                        cursor: pointer;
                    }

                    &.time-11-0:before,&.time-12-0:before {
                        content: '';
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        position: absolute;
                        background-image: linear-gradient(white 30%, transparent);
                    }
                    &.time-11-5 {
                        border-top: 1px solid $gray-300;
                        border-bottom: 1px solid $gray-300;
                    }
                    &.time-11-10:after,&.time-12-11:after {
                        content: '';
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        position: absolute;
                        background-image: linear-gradient(to top, white 30%, transparent);
                    }
                }
            }
        }

        .calendarwrap {
            position: relative;
            user-select: none;
            padding: 10px;
            grid-area: calendar;

            .datewrap {
                &.hide {
                    opacity: 0;
                }
                .monthtitle {
                    display: grid;
                    grid-template-columns: 20px 3fr 1fr 20px;
                    text-align: center;
                    font-size: 1.5em;
                    span {
                        padding: 0 2px;
                        margin: 0 2px;
                        cursor: pointer;
                        position: relative;
                        transition: background-color 0.3s;
                        border-radius: 10px;
                        &:hover {
                            background-color: $datetimepicker-hover-day;
                        }
                    }
                }

                .monthview {
                    display: grid;
                    grid-template-columns: repeat(7, 1fr);
                    .day, .dayTitle {
                        padding: 3px;
                        margin: 2px;
                        text-align: center;
                        transition: background-color 0.3s;
                        border-radius: 10px;
                        &.dayTitle {
                            font-weight: bold;
                        }
                        &.day {
                            cursor: pointer;
                            &.not-valid {
                                color: $datetimepicker-othermonth-day;
                            }
                            &:hover {
                                background-color: $datetimepicker-hover-day;
                            }
                            &.selected {
                                background-color: $datetimepicker-selected-day !important;
                                font-weight: bold;
                            }
                            &.blocked {
                                color: $datetimepicker-blocked-day;
                                background-color: initial;
                                cursor: default;
                            }
                        }
                    }
                }
            }

            .cancelListView {
                margin-top: 5px;
                text-align: right;
                .cancelButton {
                    cursor: pointer;
                    padding: 5px;
                    border-radius: 20%;
                    &:hover {
                        background-color: $datetimepicker-hover-day;
                    }
                }
                flex: 0 0 auto;
            }
            .monthwrap, .yearwrap {
                display: flex;
                flex-direction: column;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;

                .monthlist {
                    flex: 1;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    grid-template-rows: repeat(4, 1fr);
                }
                .yearlist {
                    flex: 1;
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    grid-template-rows: repeat(5, 1fr);
                }
                .month, .year {
                    margin: 5px;
                    padding: 5px;
                    cursor: pointer;
                    text-align: center;
                    transition: background-color 0.3s;
                    border-radius: 10px;

                    &:hover {
                        background-color: $datetimepicker-hover-day;
                    }
                    &.selected {
                        background-color: $datetimepicker-selected-day !important;
                        font-weight: bold;
                    }
                    &.blocked {
                        color: $datetimepicker-blocked-day;
                        cursor: default;
                        background-color: initial;
                    }
                }
            }
        }
    }

</style>
